import React from 'react';
import BackButton from '@/components/BackButton';

const Disclaimer: React.FC = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <BackButton />
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto prose prose-slate dark:prose-invert">
          <h1>Disclaimer</h1>
          
          <h2>Educational Purpose</h2>
          <p>
            NEXUS Phish is designed and intended solely for educational and research purposes. 
            This platform should only be used for authorized security testing and phishing awareness training.
          </p>

          <h2>Legal Notice</h2>
          <p>
            Users of NEXUS Phish must:
          </p>
          <ul>
            <li>Obtain proper authorization before conducting any tests</li>
            <li>Comply with all applicable laws and regulations</li>
            <li>Use the platform responsibly and ethically</li>
            <li>Respect privacy and data protection requirements</li>
          </ul>

          <h2>Prohibited Uses</h2>
          <p>
            The following activities are strictly prohibited:
          </p>
          <ul>
            <li>Unauthorized phishing attempts</li>
            <li>Malicious use of the platform</li>
            <li>Collection of real user credentials without consent</li>
            <li>Distribution of collected information</li>
            <li>Any illegal or harmful activities</li>
          </ul>

          <h2>Limitation of Liability</h2>
          <p>
            NEXUSCIPHERGUARD INDIA:
          </p>
          <ul>
            <li>Is not responsible for misuse of the platform</li>
            <li>Makes no warranties about platform reliability</li>
            <li>Is not liable for any damages or losses</li>
            <li>Reserves the right to terminate access for violations</li>
          </ul>

          <h2>Data Collection Notice</h2>
          <p>
            Users acknowledge that:
          </p>
          <ul>
            <li>All data collection must be authorized</li>
            <li>Collected data must be handled securely</li>
            <li>Privacy laws must be respected</li>
            <li>Data should be promptly deleted after testing</li>
          </ul>

          <h2>Acknowledgment</h2>
          <p>
            By using NEXUS Phish, users acknowledge:
          </p>
          <ul>
            <li>Understanding of these terms</li>
            <li>Agreement to use the platform responsibly</li>
            <li>Acceptance of all risks involved</li>
            <li>Compliance with legal requirements</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;